import { render, staticRenderFns } from "./ReMapAddress.vue?vue&type=template&id=78851479&scoped=true"
import script from "./ReMapAddress.vue?vue&type=script&lang=js"
export * from "./ReMapAddress.vue?vue&type=script&lang=js"
import style0 from "./ReMapAddress.vue?vue&type=style&index=0&id=78851479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78851479",
  null
  
)

export default component.exports